
<div class="under-dev-container">
  @if(component()) {
    <div><b>{{ component() }}</b></div>
  }
  <div>Under Development</div>
  <fa-icon icon="screwdriver-wrench" size="2x"></fa-icon>
</div>